import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }

  success(message: string) {
    Swal.fire({
      title: 'Success!',
      text: message,
      timer: 3000,
      icon: 'success',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK'
    })
  }


  successKh(message: string) {
    Swal.fire({
      title: 'ជោគជ័យ!',
      text: message,
      timer: 3000,
      icon: 'success',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK'
    })
  }

  error(message: string) {
    Swal.fire({
      title: 'Failed!',
      text: message,
      timer: 3000,
      icon: 'error',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK'
    })
  }
}
